/**
 * @ngdoc directive
 * @name adjust.directive:flyout
 * @scope
 * @restrict A
 *
 * @description
 * Parent flyout directive
 *
 */
function flyout() {
  'ngInject';
  return {
    restrict: 'A',
    scope: {},
    controller: 'FlyoutController',
    controllerAs: 'vm',
    bindToController: {
      flyout: '@?',
    },
  };
}

/**
 * @ngdoc controller
 * @name adjust.controller:FlyoutController
 *
 * @description
 * All the functionality of the {@link adjust.directive:flyout flyout} directive
 *
 */
function FlyoutController($element, $scope, $rootScope, $document) {
  'ngInject';
  var vm = this;
  // eslint-disable-next-line prefer-destructuring
  var _container = $element[0];

  vm.flyoutId = vm.flyout || null;

  _container.classList.add('flyout');

  vm.getTop = getTop;
  vm.toggle = toggle;

  $scope.$on('flyout:toggle', toggle);
  $document.on('click', _handleOutsideClick);
  $element.on('$destroy', _handleDestroy);

  /**
   * @ngdoc method
   * @name getTop
   * @methodOf adjust.controller:FlyoutController
   *
   * @description
   * Get the top position by using height of the parent
   *
   * @returns {number} top position
   */
  function getTop() {
    return _container.offsetHeight;
  }

  /**
   * @ngdoc method
   * @name toggle
   * @methodOf adjust.controller:FlyoutController
   *
   * @description
   * Toggle flyout visibility
   *
   */
  function toggle() {
    const newStatus = !_container.classList.contains('flyout-show');

    _broadcastStatus(newStatus);
    _container.classList.toggle('flyout-show', newStatus);
  }

  /**
   * @ngdoc method
   * @name _handleOutsideClick
   * @methodOf adjust.controller:FlyoutController
   *
   * @description
   * Checks for the outside click to hide the flyout
   *
   * @param {Object} evt click event
   *
   * @private
   */
  function _handleOutsideClick(evt) {
    if (!_container.contains(evt.target)) {
      _broadcastStatus(false);
      _container.classList.remove('flyout-show');
    }
  }

  /**
   * @ngdoc method
   * @name _handleDestroy
   * @methodOf adjust.controller:FlyoutBtnController
   *
   * @description
   * Detaches click event when directive is destroyed
   *
   * @private
   */
  function _handleDestroy() {
    $document.off('click', _handleOutsideClick);
  }

  function _broadcastStatus(status) {
    if (!vm.flyoutId) {
      return;
    }

    const eventName = status ? 'open' : 'closed';
    $rootScope.$broadcast(`flyout:${eventName}:${vm.flyoutId}`);
  }
}

/**
 * @ngdoc directive
 * @name adjust.directive:flyoutBtn
 * @scope
 * @restrict A
 *
 * @description
 * Flyout toggle button
 *
 */
function flyoutBtn(Helper) {
  'ngInject';
  return {
    restrict: 'A',
    scope: {},
    controller: 'FlyoutBtnController',
    require: ['flyoutBtn', '^flyout'],
    link: Helper.linkFunction,
  };
}

/**
 * @ngdoc controller
 * @name adjust.controller:FlyoutBtnController
 *
 * @description
 * All the functionality of the {@link adjust.directive:flyoutBtn flyoutBtn} directive
 *
 */
function FlyoutBtnController($element) {
  'ngInject';
  var vm = this;
  // eslint-disable-next-line prefer-destructuring
  var _container = $element[0];

  vm.init = init;

  $element.on('click', _handleClick);
  $element.on('$destroy', _handleDestroy);

  /**
   * @ngdoc method
   * @name init
   * @methodOf adjust.controller:FlyoutBtnController
   *
   * @description
   * Register parent controller and prepare the class
   *
   * @param {Object} parentController parent controller
   */
  function init(parentController) {
    vm.parentController = parentController;

    _container.classList.add('flyout-btn');
  }

  /**
   * @ngdoc method
   * @name _handleClick
   * @methodOf adjust.controller:FlyoutBtnController
   *
   * @description
   * Handle flyout button click
   *
   * @private
   */
  function _handleClick() {
    vm.parentController.toggle();
  }

  /**
   * @ngdoc method
   * @name _handleDestroy
   * @methodOf adjust.controller:FlyoutBtnController
   *
   * @description
   * Detaches click event when directive is destroyed
   *
   * @private
   */
  function _handleDestroy() {
    $element.off('click', _handleClick);
  }
}

/**
 * @ngdoc directive
 * @name adjust.directive:flyoutContent
 * @scope
 * @restrict A
 *
 * @description
 * Flyout content
 *
 */
function flyoutContent(Helper) {
  'ngInject';
  return {
    restrict: 'A',
    scope: {},
    controller: 'FlyoutContentController',
    require: ['flyoutContent', '^flyout'],
    link: Helper.linkFunction,
  };
}

/**
 * @ngdoc controller
 * @name adjust.controller:FlyoutContentController
 *
 * @description
 * All the functionality of the {@link adjust.directive:flyoutContent flyoutContent} directive
 *
 */
function FlyoutContentController($element) {
  'ngInject';
  var vm = this;
  // eslint-disable-next-line prefer-destructuring
  var _container = $element[0];

  vm.init = init;

  /**
   * @ngdoc method
   * @name init
   * @methodOf adjust.controller:FlyoutContentController
   *
   * @description
   * Register parent controller, prepare class and do some adjustments with position
   *
   * @param {Object} parentController parent controller
   */
  function init(parentController) {
    vm.parentController = parentController;

    _container.classList.add('flyout-content');
    _container.style.top = vm.parentController.getTop() + 10 + 'px';
  }
}

export { FlyoutContentController, flyoutContent, FlyoutBtnController, flyoutBtn, FlyoutController, flyout };
